import type { TopVideosResponse } from '@qlk/shared';

import { EmptyState, Skeleton } from '../../../../ui/index.js';
import { gonSo } from '../dinhDang.js';

/**
 * "Video nổi bật" phiên bản **gọn** cho cột phải của trang Hiệu suất.
 *
 * Khác `BangVideoNoiBat` (bảng đầy đủ: CTR, thời lượng, RPM, nhạc đã dùng) ở
 * chỗ cột phải chỉ rộng ~2/5 trang, nhét một bảng bảy cột vào đó là bảng cuộn
 * ngang trong một khung đã hẹp. Ở đây chỉ ảnh thu nhỏ · tên · kênh · lượt xem.
 */

export interface VideoNoiBatGonProps {
  du: TopVideosResponse | undefined;
  dangTai: boolean;
  soDong?: number;
}

export function VideoNoiBatGon({ du, dangTai, soDong = 5 }: VideoNoiBatGonProps) {
  const items = (du?.items ?? []).slice(0, soDong);

  return (
    <section className="rounded-the border border-vien bg-be-mat p-6">
      <h2 className="text-tieu-de-khoi font-semibold text-chu">Video nổi bật</h2>
      <p className="mt-1 text-phu text-chu-mo">Nhiều lượt xem nhất trong kỳ.</p>

      {dangTai ? (
        <ul className="mt-4 flex flex-col gap-3" aria-hidden="true">
          {Array.from({ length: soDong }).map((_, i) => (
            <Skeleton key={`khung-${String(i)}`} cao="3rem" />
          ))}
        </ul>
      ) : items.length === 0 ? (
        <EmptyState title="Chưa có video nào trong kỳ này" />
      ) : (
        <ol className="mt-4 flex flex-col gap-3">
          {items.map((v) => (
            <li key={v.videoId} className="flex items-center gap-3">
              {v.thumbnailUrl ? (
                <img
                  src={v.thumbnailUrl}
                  alt=""
                  loading="lazy"
                  className="size-[48px] shrink-0 rounded-o object-cover"
                  width={48}
                  height={48}
                />
              ) : (
                /* Không có ảnh thì vẫn chừa đúng chỗ đó, nếu không mỗi dòng
                   lại thụt ra thụt vào theo việc YouTube có trả ảnh hay không. */
                <span
                  aria-hidden="true"
                  className="size-[48px] shrink-0 rounded-o bg-neutral-nen"
                />
              )}

              <div className="min-w-0 flex-1">
                <p className="truncate text-co-ban text-chu" title={v.title}>
                  {v.title}
                </p>
                <p className="truncate text-phu text-chu-mo">{v.channelName}</p>
              </div>

              <span className="so-lieu shrink-0 font-semibold text-chu">{gonSo(v.views)}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
